import { render, staticRenderFns } from "./sopInfo.vue?vue&type=template&id=5335903a"
import script from "./sopInfo.vue?vue&type=script&lang=js"
export * from "./sopInfo.vue?vue&type=script&lang=js"
import style0 from "./sopInfo.vue?vue&type=style&index=0&id=5335903a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5335903a')) {
      api.createRecord('5335903a', component.options)
    } else {
      api.reload('5335903a', component.options)
    }
    module.hot.accept("./sopInfo.vue?vue&type=template&id=5335903a", function () {
      api.rerender('5335903a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/sopInfo.vue"
export default component.exports